import { I as o } from "../../../iconLoader.gen-sImvjIkd.js";
const n = /* @__PURE__ */ new Map();
async function c(e) {
  if (typeof e != "string" || !(e in o)) {
    console.error("Invalid icon name:", e);
    return;
  }
  if (n.has(e))
    return n.get(e);
  try {
    const t = await o[e](), s = new DOMParser(), i = new XMLSerializer(), r = s.parseFromString(t.default, "image/svg+xml").documentElement;
    if (r.tagName !== "svg")
      throw new Error("Loaded icon is not an SVG element");
    r.setAttribute("role", "presentation"), r.setAttribute("aria-hidden", "true");
    const a = i.serializeToString(r);
    return n.set(e, a), a;
  } catch (t) {
    console.error("Failed to load icon:", e, t);
  }
}
export {
  c as loadIcon
};
//# sourceMappingURL=index.js.map
